module.exports = __webpack_public_path__ + "static/media/iceland4.e68929be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/iceland4.jpg
// module id = 40
// module chunks = 0